import { render } from "./GoogleButton.vue?vue&type=template&id=257919e8"
const script = {}
script.render = render

export default script